/**
 * `components.MuiCssBaseline` — global `<legend>` overflow/ellipsis defaults.
 * Discoverability: `MuiCssBaseline`, `CssBaseline`, `legend`.
 *
 * @see https://mui.com/material-ui/api/css-baseline/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiCssBaseline(_theme: Theme): Pick<Components<Theme>, 'MuiCssBaseline'> {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        legend: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      },
    },
  };
}
